import _ from 'lodash';
import React from 'react';
import { clientRecordStatuses } from '~/lookups';
import SingleSelectFilter from './SingleSelectFilter';

const defaultOptions = _.values(clientRecordStatuses);

export default function ClientRecordStatusFilter({
  placeholder = 'Client Archived',
  name,
  onChange,
  value,
  options = defaultOptions,
}) {
  return (
    <SingleSelectFilter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.name}
      options={options}
      onChange={onChange}
    />
  );
}
